// ============================================
// THIS IS THE VUE3 VERSION OF THIS COMPONENT.
// For the Vue2 version, see:
// ../../../../js/components/BannerOffers/BannerOfferService.js
// ============================================
// ...existing code copied from Vue2 below...

export default {
  data() {
    return {
      ismobile: window.ismobile,
      isMazda: window.themeName.toLowerCase().includes('mazda'),
      designType: '',
      imageColSpace: 'col-lg-8',
      paymentsColSpace: 'col-md-5 col-lg-5 col-xl-4',
      imgCol: 'col-9',
      logoCol: 'col-3',
      isHonda: window.themeName.toLowerCase().includes('honda'),
      addMarginTop: false,
      disclaimerOnBanner: window.showDisclaimerOnBanners,
      showReadMore: false,
      showStyleBodyType: ['honda', 'mercedes-benz'].includes(window.themeName.toLowerCase()),
      displayPlayButton: false,
      mobileLayoutClass: '',
    };
  },
  computed: {
    bannerClasses() {
      return this.disclaimerOnBanner ? 'banner-has-disclaimer' : '';
    },
  },
  mounted() {
    if (this.bannerdata) {
      if (this.ismobile) {
        let mobileBannerDesignType = this.bannerdata.mobileImageSizeType?.toLowerCase();
        if (mobileBannerDesignType === 'large') {
          this.mobileLayoutClass = 'mobile_layout ml-size';
        } else {
          this.mobileLayoutClass = 'mobile_layout mm-size';
        }
      } else {
        this.getDesignType(this.bannerdata);
      }
    }
  },

  methods: {
    dateCheck(from, to, check) {
      const fromDate = Date.parse(from);
      const toDate = Date.parse(to);
      const checkDate = Date.parse(check);
      return checkDate <= toDate && checkDate >= fromDate;
    },
    setOfferPosition(banner) {
      let bannerStyles = {};
      if (!banner) {
        return;
      }
      if (this.ismobile) {
        bannerStyles = {
          'flex-direction': 'column',
          'flex-wrap': 'nowrap',
        };
        return bannerStyles;
      } else if (banner.position && banner.position.toLowerCase() === 'left') {
        bannerStyles = {
          'flex-direction': 'row-reverse',
        };
      } else {
        bannerStyles = {
          'flex-direction': 'row',
        };
      }
      return bannerStyles;
    },
    setTextColor(textColor) {
      return { color: textColor };
    },
    setBgcolor(bgColor, opacity) {
      if (!bgColor) {
        return {};
      }
      if (!opacity) {
        return { backgroundColor: bgColor };
      }
      let opacityValue = +opacity;
      opacityValue = opacityValue.toString();
      try {
        let hex = bgColor.replace(/^#/, '');
        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return { background: `rgb(${r},${g},${b},.${opacityValue})` };
      } catch (e) {
        console.log(e);
      }
    },
    getLogoDimensions(bannerData, height) {
      let url = this.ismobile ? bannerData?.mobileLogoImageUrl : bannerData?.desktopLogoImageUrl;
      if (url.includes('service.secureoffersites.com')) {
        return `${url}`;
      }
      return url;
    },
    getDesignType(bannerData) {
      let bannerDesignType = bannerData.imageSizeType?.toLowerCase();
      if (bannerDesignType === 'extra-large') {
        this.designType = 'bigger_design';
        this.imageColSpace = 'col-md-6 col-lg-6 col-xl-8';
        this.imgCol = bannerData.desktopLogoImageUrl ? 'col-9' : 'col-11';
      } else if (bannerDesignType === 'large') {
        this.designType = 'medium_design';
        this.imageColSpace = 'col-md-6 col-lg-6 col-xl-8';
        this.paymentsColSpace = 'col-md-5 col-lg-5 col-xl-4';
        this.imgCol = bannerData.desktopLogoImageUrl ? 'col-9' : 'col-11';
      } else {
        this.designType = 'small_design';
        this.imageColSpace = 'col-md-7 col-lg-7 col-xl-9 col-xxl-8';
        this.paymentsColSpace = 'col-md-5 col-lg-5 col-xl-3 col-xxl-4';
        this.imgCol = bannerData.desktopLogoImageUrl ? 'col-8' : 'col-9';
        this.logoCol = 'col-4';
      }

      //six pack carousel
      if (
        document
          .getElementById('rotational-banner-component')
          ?.classList.contains('six-pack-carousel-banner')
      ) {
        this.paymentsColSpace = 'col-md-5 col-lg-5 col-xl-4';
        this.imageColSpace = 'col-md-7 col-lg-7 col-xl-8';
        this.imgCol = bannerData.desktopLogoImageUrl ? 'col-9' : 'offset-1 col-10';
        this.logoCol = 'col-3';
      }

      //image url 3 tile

      if (
        document
          .getElementById('rotational-banner-component')
          ?.classList.contains('image-url-3-tile')
      ) {
        this.paymentsColSpace = 'col-md-5 col-lg-5 col-xl-4';
        this.imageColSpace = 'col-md-7 col-lg-7 col-xl-8';
        this.imgCol = bannerData.desktopLogoImageUrl ? 'col-9' : 'offset-1 col-10';
        this.logoCol = 'col-3';
      }
    },
    setBannerContentPosition() {
      let classList = '';
      if (
        (this.bannerdata?.rotationalBannerType.toLowerCase() === 'specialoffer' ||
          this.bannerdata?.rotationalBannerType.toLowerCase() === 'vehicleoffer' ||
          this.bannerdata?.rotationalBannerType.toLowerCase() === 'vehicleapr' ||
          this.bannerdata?.rotationalBannerType.toLowerCase() === 'vehicleofinterest') &&
        (this.bannerdata?.bannerBackgroundType.toLowerCase() === 'solid-color' ||
          this.bannerdata?.bannerBackgroundType.toLowerCase() === 'gradient-color')
      ) {
        classList = 'no-img-bg-color';
      }

      return classList;
    },
    applyBannerButtonStyles(bannerData) {
      if (!bannerData) {
        return;
      }
      return {
        backgroundColor: bannerData.ctaColor + '!important',
        color: bannerData.ctaFontColor + '!important',
      };
    },
    openDisclaimer(event, offerDisclaimer) {
      this.$emit('send-Disclaimer-toParent', offerDisclaimer);
      event.stopPropagation();
    },
    showLogo(bannerData) {
      if (bannerData.logoFromDate && bannerData.logoToDate) {
        let valid = this.dateCheck(bannerData.logoFromDate, bannerData.logoToDate, new Date());
        if (!valid) {
          return false;
        }
      }
      if (this.ismobile) {
        return bannerData.mobileLogoImageUrl || false;
      }
      return bannerData.desktopLogoImageUrl || false;
    },
    vinStockSectionFontColor(bannerData) {
      if (!bannerData) {
        return;
      }
      return {
        color: bannerData.vinDisclosureFontcolor + '!important',
      };
    },
    isDealerImage(bannerData) {
      if (bannerData?.bannersPaymentHomenetVehicle?.firstPhotoUrl.includes('secureoffersites')) {
        return '';
      }
      this.addMarginTop = true;
      return 'dealer-img-border';
    },
    getTrimmedDisclaimerText(disclaimer, bannerData) {
      let trimmedDisclaimer = disclaimer;
      let characterLength = this.getCharLength(bannerData);
      if (disclaimer.length > characterLength) {
        trimmedDisclaimer = disclaimer.substr(0, characterLength);
        this.showReadMore = true;
      }
      return trimmedDisclaimer;
    },
    getCharLength(bannerData) {
      let bannerSize = bannerData.imageSizeType?.toLowerCase();
      if (this.ismobile) {
        return 500;
      } else if (bannerSize === 'extra-large' || bannerSize === 'large') {
        return window.innerWidth < 1500 ? 800 : 1400;
      } else if (bannerSize === 'medium') {
        return window.innerWidth < 1500 ? 500 : 800;
      } else {
        // No action needed for other cases.
      }
    },
    styleWithBodyType(bannerData) {
      if (!this.showStyleBodyType) {
        return '';
      }

      let label;
      if (bannerData?.rotationalBannerType.toLowerCase() === 'specialoffer') {
        label = bannerData.offer?.vehicleInfo?.styleNameWOTrim;
      } else if (window.make?.toLowerCase() === 'mercedes-benz') {
        label =
          bannerData.bannersPaymentHomenetVehicle?.vehicleDescription +
          ' ' +
          bannerData.bannersPaymentHomenetVehicle?.transmission;
      } else {
        label =
          bannerData.bannersPaymentHomenetVehicle?.drivetrain +
          ' ' +
          bannerData.bannersPaymentHomenetVehicle?.transmission;
      }

      if (
        window.make?.toLowerCase() === 'mercedes-benz' &&
        label?.toLowerCase().includes('4matic')
      ) {
        label = label.replace('4MATIC', '4MATIC®');
      }
      return label;
    },
    convertToPriceFormat(value) {
      try {
        if (typeof value === 'number') {
          value = value.toString();
        }
        if (value?.indexOf(',') > -1) {
          return value;
        }
        value = parseFloat(value);
        if (typeof value !== 'number') {
          return value;
        }
        return value.toLocaleString();
      } catch (error) {
        console.error('Error formatting number:', error);
        return '';
      }
    },
  },
};
